<template>
    <!-- BEGIN: Content-->
    <div class="mt-0">
      <div class="flex">
        <div class="section_title"><span class="big-size weight-bold">{{ $store.state.loader_text }}&nbsp;&nbsp;</span>
          <div class="load"><v-progress-circular
            color="primary"
            indeterminate
            :size="18"
            :width="3"
            v-show="loader"
          ></v-progress-circular></div>
        </div>

        <div style="display:flex;align-items:center;justify-content:space-between;flex-direction:row">
          <v-btn
            color="#000000"
            class="ma-1 white--text"
            depressed
            @click.stop="dialog = true"
          >
            Vehicle type
            <v-icon
              right
              dark
            >
              mdi-plus
            </v-icon>
          </v-btn>
        </div>
      </div>
      <div class="vehicleTypeList">
        <v-container fluid style="padding-top:0 !important;padding-bottom:0 !important">
          <v-row style="margin-top:0 !important;margin-bottom:0 !important">
            <v-col md="12" sm="12" class="py-0 my-1 px-0">
              <v-card class="card-shadow py-0">

                <v-card-text class="px-0 py-3 cardtext">
                          <div class="empty-state" v-if="vehicleType.length === 0 && !loader">
                            <div class="empty-state__content">
                              <div class="empty-state__icon">
                                <v-img src="@/assets/icon.png" alt=""></v-img>
                              </div>
                              <div class="empty-state__message">No records available.</div>
                            </div>
                          </div>
                          <v-virtual-scroll
                            :items="vehicleType"
                            :item-height="20"
                            renderless 
                            id="virtualscroll"
                            class="vehicleType"
                           >
                            <template v-slot:default="{ index,item }">
                                <div class="tcell">{{ index + 1 }}</div>
                                <div class="tcell"><img :src="item.image" style="width:20px"/></div>
                                <div class="tcell">{{ item.type }}</div>
                                <div class="tcell">
                                  <v-menu offset-x left bottom origin="center center" transition="scale-transition">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                          icon
                                          v-bind="attrs"
                                          small
                                          v-on="on">
                                        <v-icon>mdi-arrow-down-drop-circle-outline</v-icon>
                                      </v-btn>
                                    </template>
                                    
                                    <v-list-item-group
                                      color="primary"
                                      class="actions"
                                      >

                                        <v-list-item
                                          @click="editType(item.id)"
                                        >
                                            <v-list-item-icon>
                                              <v-icon color="#000000">mdi-pencil</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                              <v-list-item-title>Edit</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>

                                      <v-list-item
                                        link
                                        @click="deleteItem(item.id)"
                                        >
                                            <v-list-item-icon>
                                              <v-icon>mdi-delete</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                              <v-list-item-title>Remove</v-list-item-title>
                                            </v-list-item-content>
                                      </v-list-item>

                                    </v-list-item-group>
                                  </v-menu>
                                </div>
                            </template>
                          </v-virtual-scroll>

                    </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <!-- add user dialog -->
        <v-dialog
          v-model="dialog"
          width="400px"
          >
          <v-card>

            <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

            <v-card-title>
              <span class="text-h6">Add vehicle type</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                  <div class="row">
                      <div class="col-lg-8">
                        <img :src="previewImage" style="width:30%;"  />
                      </div>
                  </div>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-file-input
                        :rules="imageRules"
                        accept="image/png, image/jpeg, image/bmp, image/webp"
                        prepend-icon="mdi-camera"
                        label="Select vehicle image"
                        v-on:change="onChange"
                        id="image" 
                        name="image"
                      ></v-file-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        label="Type*"
                        v-model="item.type"
                        required
                        :rules="fieldRules"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="dialog = false"
                >
                  Close
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  :loading="loading"
                  :disabled="!valid"
                  @click="create"
                >
                  Save
                </v-btn>
            </v-card-actions>

          </v-form>
          </v-card>
        </v-dialog>
        <!-- end user -->
        <!-- user update modal-->
        <v-dialog
          v-model="updatedialog"
          width="400px"
          >
          <v-card>

            <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

            <v-card-title>
              <span class="text-h6">Update vehicle type</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                  <div class="row">
                      <div class="col-lg-8">
                        <img :src="previewImage" style="width:30%"  />
                      </div>
                  </div>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-file-input
                        :rules="imageRules"
                        accept="image/png, image/jpeg, image/bmp, image/webp"
                        prepend-icon="mdi-camera"
                        label="Select vehicle image"
                        v-on:change="onChange"
                        id="image" 
                        name="image"
                      ></v-file-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        label="Type*"
                        v-model="item.updatetype"
                        required
                        :rules="fieldRules"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="updatedialog = false"
                >
                  Close
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  :loading="loading"
                  :disabled="!valid"
                  @click="update"
                >
                  Save
                </v-btn>
            </v-card-actions>

          </v-form>
          </v-card>
        </v-dialog>
        <!-- update user -->
      </div>
    </div>

</template>
<style>
  .vehicleTypeList .v-virtual-scroll__item{
    width:100%;
    display: grid !important;
     grid-template-columns: 25% 25% 25% 25%;
     grid-auto-flow: column !important;
     grid-gap: 0px;
  }
</style>
<script>
import axios from 'axios'
import {ability} from '@/services/ability'
import $ from 'jquery';

export default {
    name:"vehicleTypeList",
    data(){
        return {
          fieldRules: [
          (v) => !!v || 'Field is required'
          ],
          imageRules: [
            value => !value || value.size < 2000000 || 'Image size should be less than 2 MB!',
          ],
          previewImage: null,
          search:null,
          valid: true,
          searchrole:null,
          dialog: false,
          updatedialog: false,
          breadcrumbs: [
            {
              text: 'Dashboard',
              disabled: false,
              href: '/',
            },
            {
              text: 'Business Config',
              disabled: false,
              href: '',
            },
            {
              text: 'Vehicles',
              disabled: false,
              href: '',
            },
            {
              text: 'Vehicle Type',
              disabled: false,
              href: '',
            },
          ],
          fields: [
            {
              text: '#',
              align: 'start',
              value: '#',
            },
            { text: 'Image', value: 'image' },
            { text: 'Type', value: 'type' },
            { text: 'Action', value: 'action' },
           ],
          item:{
                type:"",
                image:null,
                updatetype: "",
                updateID: "",
                _method:"patch"
            },
            loading: false,
           disabled: false,
           vehicleType: [],
           isBusy: false,
            updateModal: null
        }
    },
    beforeMount() {
      if(!ability.can('vehicle-management', 'all')) {
        this.$router.push({ name: 'Dashboard' })
        return
      }
    },
    mounted(){

      this.$store.state.loader_text = "Vehicle Type"

      this.getType()

      let headertitle = `<div class="v-virtual-scroll__container"><div class="v-virtual-scroll__item" style="top: 0px;">`;
      this.fields.map(function(value, key) {
           headertitle +=`<div class="thead">${value.text}</div>`;
         });
      headertitle +=`</div></div>`;
      $('.v-virtual-scroll').prepend(headertitle)

    },
    computed: {
      loader() {
        return this.$store.state.tableloader
      },
    },
    methods:{
      getRowClass(item) {
        return 'row-color' 
      },
      onChange(e) {
        if(e) {
          this.item.image = e;
          this.previewImage = URL.createObjectURL(this.item.image);
        }
      },
      async getType(){
        this.$store.state.tableloader = true
        await axios.get('/vehicle-type').then(response=>{
            this.$store.state.tableloader = false
            this.vehicleType = response.data.vehicleType
        }).catch(error=>{
            console.log(error)
            this.$store.state.tableloader = false
            this.vehicleType = []
        })
      },
       async create(){

        if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('type',this.item.type)
            fd.append('file',this.item.image)

            await axios.post('/vehicle-type', fd, config).then(response=>{
              this.loading = false
              this.disabled = false
              this.res = response.status
              if(this.res === parseInt(200))
                this.$toast.success(response.data.message,'Success',{position: 'topRight',timeout: 7000,})
                this.getType()
                
              this.item.type = ''
              this.item.image = null
              this.previewImage = null
              this.clear()
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

          }

        },
        clear () {
          this.$refs.form.reset()
        },
        async update(){

          if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('type',this.item.updatetype)
            fd.append('file',this.item.image)
            fd.append('_method',this.item._method)

            await axios.post(`/vehicle-type/${this.item.updateID}`, fd, config).then(response=>{
              this.loading = false
              this.disabled = false
              this.res = response.status
              if(this.res === parseInt(200))
                this.$toast.success(response.data.message,'Success',{position: 'topRight',timeout: 7000,})
                this.updatedialog = false
                this.getType()
              this.item.updatetype = ''
              this.item.image = null
              this.previewImage = null
              this.item.updateID = ''
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

          }

        },
      async editType(id) {
        let index = this.vehicleType.filter(item => item.id === id );
        this.item.updatetype = index[0].type
        this.item.updateID = index[0].id
        this.previewImage = index[0].image
        this.updatedialog = true
      },
      deleteItem(id){
            if(confirm("Are you sure to delete type ?")){
                axios.delete(`/vehicle-type/${id}`).then(response=>{
                  this.$toast.success(response.data.message,'Success',{position: 'topRight',timeout: 7000,})
                    this.getType()
                }).catch(error=>{
                    console.log(error)
                })
            }
        }

    }
}
</script>